import React, { useState, useEffect } from 'react'
import { AppHeader, AppSidebar, AppFooter } from '../../Layout'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { Loading, MsgSemRegistros, PageTitle, Select } from '../../Components'
import { Button, Card, CardBody, CardHeader, Col, Collapse, FormGroup, Input, Row, Label } from 'reactstrap'

import InteracoesDia from './InteracoesDia'
import PorTipo from './PorTipo'
import PorLaboratorio from './PorLaboratorio'
import TopInteracoes from './TopInteracoes'
import { BsSearch } from 'react-icons/bs'
import { MdExpandLess, MdExpandMore } from 'react-icons/md'
import { ConversaGet, LaboratorioGet } from '../../Service/ApiService'

import PluginChat from '../../Plugin/Chat'
import PluginBtn from '../../Plugin/BtnChat'

const initValues = { laboratorioId: [], dtInicio: '', dtTermino: '', tpServico: 0 }

export default function Dashboards() {
  const [isLoading, setIsLoading] = useState(false)
  const [isOpenFilter, setIsOpenFilter] = useState(false)

  const [dataGrid, setDataGrid] = useState()
  const [values, setValues] = useState(initValues)
  const [laboratorios, setLaboratorios] = useState([])

  async function loadLaboratorios(laboratorioId) {
    let itens = []
    let result = {}

    var response = await LaboratorioGet()
    response?.forEach((d) => {
      itens.push({ value: d.laboratorioId, label: d.nome })
      if (d.laboratorioId == laboratorioId) result = { value: d.laboratorioId, label: d.nome }
    })
    setLaboratorios(itens)

    return result
  }

  async function loadGrid(filters = values) {
    let _filters = {}
    try {
      setIsLoading(true)
      _filters.laboratorioId = []
      filters.laboratorioId?.forEach((item) => {
        _filters.laboratorioId.push(item.value)
      })
      _filters.tpServico = filters.tpServico ? parseInt(filters.tpServico, 10) : undefined
      _filters.dtInicio = filters.dtInicio
      _filters.dtTermino = filters.dtTermino

      const response = await ConversaGet(_filters)
      setDataGrid(response)
    } catch (error) {}
    setIsLoading(false)
  }

  function onChange(ev) {
    const { name, value } = ev.target
    setValues({ ...values, [name]: value })
  }
  function onChangeCat(newValue, actionMeta) {
    const { name } = actionMeta
    setValues({ ...values, [name]: newValue })
  }
  useEffect(() => {
    async function load() {
      try {
        setIsLoading(true)
        await loadLaboratorios()
        var _dtAtual = new Date()
        _dtAtual.setMinutes(_dtAtual.getMinutes() - _dtAtual.getTimezoneOffset())
        var _dtInicio2 = new Date(_dtAtual.getFullYear(), _dtAtual.getMonth() - 1, 1)
        var _dtTermino2 = new Date(_dtAtual.getFullYear(), _dtAtual.getMonth() + 1, 1)
        _dtTermino2.setDate(_dtTermino2.getDate() - 1)
        var filters = { ...initValues, dtInicio: _dtInicio2.toISOString().substr(0, 10), dtTermino: _dtTermino2.toISOString().substr(0, 10) }

        setValues(filters)
        loadGrid(filters)
      } catch {}
      setIsLoading(false)
    }
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Loading isVisible={isLoading} />
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner">
            <PageTitle heading="Dashboard" subheading="" />
            <div className="page-content">
              <div style={{ margin: 'auto 0', width: '100%' }}>
                <ReactCSSTransitionGroup component="div" transitionName="TabsAnimation" transitionAppear={true} transitionAppearTimeout={0} transitionEnter={false} transitionLeave={false}>
                  <Card className="main-card mb-1">
                    <CardHeader style={{ display: 'flex' }}>
                      Filtros
                      <Button
                        type="button"
                        onClick={() => {
                          loadGrid()
                          setIsOpenFilter(false)
                        }}
                        className="btn-pill"
                        color="primary"
                        id="btnPartPesquisar"
                        style={{ marginLeft: 'auto' }}
                      >
                        <BsSearch size={18} /> Buscar
                      </Button>
                      <Button
                        type="button"
                        onClick={() => setIsOpenFilter(!isOpenFilter)}
                        className="btn-transition btn-outline-primary btn-sm"
                        color="white"
                        id="btnPartPesquisar"
                        style={{ marginLeft: '10px' }}
                      >
                        {isOpenFilter ? <MdExpandLess size={22} /> : <MdExpandMore size={22} />}
                      </Button>
                    </CardHeader>
                    <Collapse isOpen={isOpenFilter}>
                      <CardBody>
                        <Row>
                          <Col md={2}>
                            <FormGroup>
                              <Label>Data de Início</Label>
                              <Input type="date" onChange={onChange} value={values.dtInicio} name="dtInicio" id="dtInicio" />
                            </FormGroup>
                          </Col>
                          <Col md={2}>
                            <FormGroup>
                              <Label>Data de Término</Label>
                              <Input type="date" onChange={onChange} value={values.dtTermino} name="dtTermino" id="dtTermino" />
                            </FormGroup>
                          </Col>
                          <Col md={`3`}>
                            <FormGroup>
                              <Label>Tipo serviço *</Label>
                              <Input type="select" className="form-control" onChange={onChange} value={values.tpServico} id="tpServico" name="tpServico">
                                <option value=""></option>
                                <option value={1}>Análises e Ensaios Laboratoriais</option>
                                <option value={2}>Serviços Tecnológicos</option>
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col md={5}>
                            <FormGroup>
                              <Label>Laboratórios</Label>
                              <Select
                                placeholder="Selecione"
                                noOptionsMessage={() => 'Nenhuma opção disponível'}
                                onChange={onChangeCat}
                                value={values.laboratorio}
                                isClearable
                                closeMenuOnSelect={false}
                                name="laboratorioId"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                options={laboratorios}
                                isMulti
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    </Collapse>
                  </Card>

                  {dataGrid ? (
                    <Row>
                      <>
                        <Col md={8}>
                          <InteracoesDia dataGrid={dataGrid} />
                          <PorLaboratorio dataGrid={dataGrid} />
                        </Col>
                        <Col md={4}>
                          <PorTipo dataGrid={dataGrid} />
                          <TopInteracoes dataGrid={dataGrid} />
                        </Col>
                      </>
                    </Row>
                  ) : (
                    <Card className="main-card ">
                      <CardBody>
                        <MsgSemRegistros />
                      </CardBody>
                    </Card>
                  )}
                </ReactCSSTransitionGroup>
              </div>
            </div>
          </div>
          <AppFooter />
        </div>
      </div>

      <PluginBtn />
      <PluginChat />
    </>
  )
}
